import _typeof from "/data/jenkins/workspaces/workspace/h5/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.keys.js";

/* eslint-disable one-var */

/**
 * @func 通用函数构造
 */
var utils = {
  /**
   * @func 获取url参数列表 带#的获取, 加入当前路由
   **/
  getUrlParam2: function getUrlParam2(url) {
    url = url || window.location.href;
    var uri = url.split('?');
    var obj = {};
    obj.route = uri[0].split('/#')[1];
    if (!uri[1]) return obj; // 无参情况

    var arr = uri[1].split('&');
    arr.forEach(function (x) {
      var kv = x.split('=');
      obj[kv[0]] = kv[1].split('#')[0];
    });
    return obj;
  },

  /**
   * @func 获取url参数列表   不带#的获取,
   **/
  getUrlParam: function getUrlParam(url) {
    url = url || window.location.href;
    var obj = {};

    if (url.indexOf('?') > -1) {
      var uri = url.split('?');
      var arr = uri[1].split('&');
      arr.forEach(function (x) {
        var kv = x.split('=');
        obj[kv[0]] = kv[1];
      });
    }

    return obj;
  },
  paramDeal: function paramDeal(url) {
    url = url || window.location.search;
    url = decodeURIComponent(url); // 对url进行解码,防止url被编码

    var obj = {}; // 单独处理service参数 service之后一律认为为service的value

    if (url.indexOf('service') > -1) {
      var serAll = url.substring(url.indexOf('service') - 1);
      url = url.substring(0, url.indexOf('service') - 1);
      serAll = serAll.substring(serAll.indexOf('service'));
      obj.serviceAll = serAll.substring(serAll.indexOf('=') + 1);
      var ser = serAll.split('?');
      obj.service = ser[0].substring(ser[0].indexOf('=') + 1);
    }

    if (url.indexOf('?') > -1) {
      var str = url.substring(url.indexOf('?') + 1);
      var arr = str.split('&');

      for (var i = 0; i < arr.length; i++) {
        var param = arr[i].split('=');
        obj[param[0]] = param[1];
      }
    }

    return obj;
  },

  /**
   * @func ，把对象转为拼接的字符串,用于url参数的拼接,例如?a=1b&=2$c=3
   **/
  objSerialize: function objSerialize(obj) {
    var param = '';
    var arr = [];

    for (var key in obj) {
      arr.push(key);
    }

    arr.forEach(function (v, i) {
      param += i === 0 ? '?' : '&';
      param += v + '=' + obj[v];
    });
    return param;
  },

  /**
   * @func 根据ua判断终端类型
   **/
  isMobile: function isMobile() {
    var Mobile = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    var ua = navigator.userAgent;
    return Mobile.some(function (x) {
      return ua.indexOf(x) >= 0;
    });
  },

  /**
   * @func 获取cookie
   */
  getCookie: function getCookie() {
    var arr;
    var reg = new RegExp('(^| )' + 'CASTGC' + '=([^;]*)(;|$)');

    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  setcookie: function setcookie(name, value) {
    if (value === 'null' || value === 'undefined') return;
    var exp = new Date(); // 写入Cookie  ，toGMTstring将时间转换成字符串。

    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString;
  },

  /**
   * @func 弱提示消息窗口
   **/
  notify: function notify(vm, type, info) {
    var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1500;
    var msg = type === 'success' ? '操作成功' : type === 'error' ? '操作失败' : '';
    vm.$message({
      message: info || msg,
      type: type,
      duration: duration
    });
  },

  /**
   * @func 抛出错误，便于调试
   * @param vm-实例对象，可不传，此时页面不会提示错误。 e-异常对象，控制台打印错误信息
   **/
  throwError: function throwError(vm, e) {
    arguments.length === 1 && (e = vm);
    arguments.length === 2 && this.notify(vm, 'error', e.message);
  },

  /**
   * Parse the time to string
   * @param {(Object|string|number)} time
   * @param {string} cFormat
   * @returns {string}
   */
  parseTime: function parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null;
    }

    var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    var date;

    if (_typeof(time) === 'object') {
      date = time;
    } else {
      if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
        time = parseInt(time);
      }

      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000;
      }

      date = new Date(time);
    }

    var formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    };
    var timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, keymap) {
      var value = formatObj[keymap]; // Note: getDay() returns 0 on Sunday

      if (keymap === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value];
      }

      if (result.length > 0 && value < 10) {
        value = '0' + value;
      }

      return value || 0;
    });
    return timeStr;
  },
  // 数组去重
  reWeight: function reWeight(arr) {
    var obj = {};
    var newArr = [];

    for (var i = 0; i < arr.length; i++) {
      if (!obj[arr[i]]) {
        // obj中有没有这个属性
        obj[arr[i]] = true; // 如果没有添加此属性

        newArr.push(arr[i]); // 然后将其添加进新数组
      }
    }

    return newArr;
  },
  // 判断ios版本
  judgeIos: function judgeIos() {
    var ua = navigator.userAgent && navigator.userAgent.toLowerCase();

    if (ua.indexOf('like mac os x') > -1) {
      var reg = /os [\d._]*/gi;
      var verinfo = ua.match(reg);
      var version = (verinfo + '').replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.');
      var arr = version.split('.');
      return arr[0];
    }

    return 0;
  },

  /**
   * Merges two objects, giving the last one precedence
   * @param {Object} target
   * @param {(Object|Array)} source
   * @returns {Object}
   */
  objectMerge: function objectMerge(target, source) {
    if (_typeof(target) !== 'object') {
      target = {};
    }

    if (Array.isArray(source)) {
      return source.slice();
    }

    Object.keys(source).forEach(function (property) {
      var sourceProperty = source[property];

      if (_typeof(sourceProperty) === 'object') {
        target[property] = utils.objectMerge(target[property], sourceProperty);
      } else {
        target[property] = sourceProperty;
      }
    });
    return target;
  },

  /**
   * @param {HTMLElement} element
   * @param {string} className
   */
  toggleClass: function toggleClass(element, className) {
    if (!element || !className) {
      return false;
    }

    var classString = element.className;
    var nameIndex = classString.indexOf(className);

    if (nameIndex === -1) {
      classString += '' + className;
    } else {
      classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
    }

    element.className = classString;
  },
  // 判断是哪个系统
  WhichSystem: function WhichSystem() {
    var agent = navigator.userAgent && navigator.userAgent.toLowerCase();
    var isMac = /macintosh|mac os x/i.test(navigator.userAgent);

    if (agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0) {
      return 'windows';
    }

    if (agent.indexOf('win64') >= 0 || agent.indexOf('wow64') >= 0) {
      return 'windows';
    }

    if (isMac) {
      return 'mac';
    }
  },
  // 获取当前云图梭跳转域名
  getYtsUrl: function getYtsUrl(url) {
    var locationUrl = url || window.location.href.split('?')[0];

    if (locationUrl.indexOf('sit') !== -1 || locationUrl.indexOf('passporttest') !== -1) {
      return 'https://pwb.longfor.sit/yts/workbench';
    }

    if (locationUrl.indexOf('uat') !== -1 || locationUrl.indexOf('passportuat') !== -1) {
      return 'https://pwb.longfor.uat/yts/workbench';
    }

    if (locationUrl.indexOf('passport-pre') !== -1) {
      return 'https://pwb-pre.longfor.com/yts/workbench';
    }

    if (locationUrl.indexOf('passport.longhu.net') !== -1 || locationUrl.indexOf('sso.longfor.com') !== -1) {
      return 'https://iwork.longfor.com/';
    }
  },
  // 统一协议
  uniteProtocol: function uniteProtocol(url) {
    if (window.location.href.slice(0, 5) === 'https' && url.slice(0, 5) !== 'https') {
      return url.replace(/http:\/\//, 'https://');
    } else if (window.location.href.slice(0, 5) !== 'https' && url.slice(0, 5) === 'https') {
      return url.replace(/https:\/\//, 'http://');
    } else {
      return url;
    }
  },
  // 不允许中文字符
  passwordRegexp: function passwordRegexp(value) {
    return value.replace(/[\u4e00-\u9fa5\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/gm, '');
  },
  // 登录方式埋点
  loginZhuge: function loginZhuge(title, method) {
    try {
      window.zhuge.track(title, {
        '登录方式': method
      });
    } catch (e) {
      console.log("".concat(title, "_zhuge"), e);
    }
  },
  // 埋点
  zhugeTrack: function zhugeTrack(title, data) {
    try {
      window.zhuge.track(title, data);
    } catch (e) {
      console.log("".concat(title, "_zhuge"), e);
    }
  }
};
export default utils;